import { IDataTypeSerializer, IDataType, ISerializeContext, Property } from '@ecp-caf/common-structure';
import { ExtendStrucutreType } from '../../../define/data-type/extend-structure-type';
import { DtoConstant } from '../../../define/gsp-dto-constant';
import { StructureTypeEnum } from '../../../define/structure-type-enum';

export class ExtendStructureTypeSerializer implements IDataTypeSerializer{

    serialize(type:IDataType, ctxt: ISerializeContext): Object {
        let extendDtoType=type as ExtendStrucutreType;
        if(!extendDtoType){
            return null;
        }
        let jobj=new Object();
        jobj['kind']=DtoConstant.EXTEND_STRUCTURE_TYPE;
        jobj['id']=extendDtoType.id;
        jobj['code']=extendDtoType.code;
        jobj['name']=extendDtoType.name;
        jobj['description']=extendDtoType.description;
        jobj['uri']=extendDtoType.uri;
        jobj['root']=extendDtoType.root;
        jobj['structureType']=extendDtoType.structureType;
        if(extendDtoType.properties){
            let jarry=jobj['properties']=new Array<Object>();
            extendDtoType.properties.forEach(prop => {
                let serializer=ctxt.getPropertySerializerFactory().get(prop.kind);
                jarry.push(serializer.serialize(prop,ctxt));
            });
        }
        return jobj;
    }    
    
    deserialize(jobj: Object, ctxt: ISerializeContext): IDataType {
        if(!jobj){
            return null;
        }
        let structureType=new ExtendStrucutreType();
        structureType.kind=jobj['kind'];
        structureType.id=jobj['id'];
        structureType.code=jobj['code'];
        structureType.name=jobj['name'];
        structureType.description=jobj['description'];
        structureType.root=jobj['root'] as boolean;
        structureType.uri=jobj['uri'];
        structureType.structureType=jobj['structureType'] as StructureTypeEnum;
        if(jobj['properties']){
            structureType.properties=new Array<Property>();
            jobj['properties'].forEach(structureTypeProp => {
                let serializer= ctxt.getPropertySerializerFactory().get(structureTypeProp.kind);
                structureType.properties.push(serializer.deserialize(structureTypeProp,ctxt));
            });
        }
        return structureType;
    }

}